// extracted by mini-css-extract-plugin
export default {"ctaContainer":"u5MnNzELViuuHYHbujES","img":"NcO9ZK2CAtAmXUd65yka","text":"_RsVjdeGx7il1aF9wcto"};